(function() {
	'use strict';

	var $ = avm.require('cash'),
		waypoints = avm.require('avast.web.waypoints'),
		$window = $(window),
		$worldSecurity = $('.js-world-security'),
		$animationAnchors = $('[data-aos-anchor-placement]'),
		isWorldSecurityInViewport = false,
		mediaQuery = (function() {
			return (window.getComputedStyle) ? window.getComputedStyle(document.body, ':after').getPropertyValue('content') : '';
		})(),
		isDesktop = mediaQuery.indexOf('desktop') > -1;

	// replace anchor placement positions for mobile and tablet
	(function() {
		if (!isDesktop) {
			$animationAnchors.attr('data-aos-anchor-placement', 'top-bottom');
		}
	})();

	/** securityInViewport - Animate security on scroll */
	function securityInViewport() {
		if (waypoints($worldSecurity, 200)) {
			if (isWorldSecurityInViewport) {
				$window.off('scroll', securityInViewport);
			} else {
				isWorldSecurityInViewport = true;
				$worldSecurity.addClass('animate');
			}
		}
	}

	$window.on('scroll', securityInViewport);

	function counting() {
		if (waypoints($worldSecurity, 0)) {
			var timeout = setTimeout(function () {
				$(".js-info").each(function () {

					var $this = $(this),
						countUp = $this.attr("data-count");
					var tick = 1000 / countUp;

					function updateTimer(currentNum) {
						if (currentNum <= countUp) {
							$this.text(currentNum);
							currentNum++;
							setTimeout(updateTimer, tick, currentNum);
						}
					}
					updateTimer($this.text());
				});
				clearTimeout(timeout);
			}, 500);
		}
	}

	$window.on('scroll', counting);
})();
